import {TranslateService} from '@ngx-translate/core';

import {LocalizationService} from '../../../../../shared/localization/localization.service';
import {Chart} from '../../key-metrics.interfaces';

import {Pie} from './pie';

export class BasicPie extends Pie {
  constructor(chart: Chart,
              translate: TranslateService,
              localization: LocalizationService) {
    super(chart, translate, localization);
    this.createCircleChart();
  }
}
